import axios from "../libs/api.request.js";
// import config from '@/config'
// 登录
export const login = params => {
  return axios.request({
    url: "memberLogin",
    method: "post",
    params: params
  });
};
// 退出登录

export const loginout = params => {
  return axios.request({
    url: "logout",
    method: "post",
    data:params
  });
};
// 客户列表
export const customer = params => {
  return axios.request({
    url: "pc/customer",
    method: "get",
    params: params
  });
};
// 保存客户
export const saveCustomer = params => {
  return axios.request({
    url: "pc/customer",
    method: "post",
    data: params
  });
};
// 客户详情
export const getOne = params => {
  return axios.request({
    url: "pc/customer/getOne",
    method: "get",
    params
  });
};
// 客户消息
export const news = params => {
  return axios.request({
    url: "pc/news",
    method: "get",
    params
  });
};
// 客户已读
export const updateMessageRead = params => {
  return axios.request({
    url: "pc/newsread/updateMessageRead",
    method: "get",
    params
  });
};
// 删除消息
export const updateMessageDelete = params => {
  return axios.request({
    url: "pc/newsread/updateMessageDelete",
    method: "get",
    params
  });
};
// 消息全部已读
export const updateMessageReadAll = params => {
  return axios.request({
    url: "pc/newsread/updateMessageReadAll",
    method: "get",
    params
  });
};
// 子账号列表
export const cashDetails = params => {
  return axios.request({
    url: "pc/memberCash/cashDetails",
    method: "get",
    params
  });
};
//账户启用禁用
export const updateMemberStatus = data => {
  return axios.request({
    url: "pc/member/updateMemberStatus",
    method: "post",
    data
  });
};
//提交编辑
export const balanceDistribution = data => {
  return axios.request({
    url: "pc/memberCash/balanceDistribution",
    method: "post",
    data
  });
};
//获得当前帐号的子账号
export const findAllSubAccount = params => {
  return axios.request({
    url: "pc/member/findAllSubAccount",
    method: "get",
    params
  });
};
//余额分配明细
export const allocationDetails = params => {
  return axios.request({
    url: "/pc/memberDeal/allocationDetails",
    method: "get",
    params
  });
};
//类型
export const getTransactionType = params => {
  return axios.request({
    url: "/pc/memberDeal/getTransactionType",
    method: "get",
    params
  });
};
//个人信息
export const getAccountInfo = params => {
  return axios.request({
    url: "/pc/member/getAccountInfo",
    method: "get",
    params
  });
};
//权限
export const getMemberAuthority = params => {
  return axios.request({
    url: "/admin/memberdetail/getMemberAuthority",
    method: "get",
    params
  });
};
//客户信息
export const getCust = params => {
  return axios.request({
    url: "/pc/customer/getCust",
    method: "get",
    params
  });
};
//客户余额
export const getCustBalance = params => {
  return axios.request({
    url: "/pc/memberCash/balance",
    method: "get",
    params
  });
};
//修改密码
export const changePasswordByOriginalPassword = data => {
  return axios.request({
    url: "/pc/member/changePasswordByOriginalPassword",
    method: "post",
    data
  });
};

// 导入客户CSV数据
export const importCustomerCsv = data => {
  return axios.request({
    url: "/pc/customer/importOnNlnbu",
    method: "post",
    data,
  });
};



// WEBPACK FOOTER //
// ./src/api/user.js